import { Controller } from "@hotwired/stimulus"

export default class TicketCategoryController extends Controller {
  static targets = ["question", "questionContainer", "answer", "answerContainer"];

  static values = {
    hideSelectedQuestion: Boolean
  };

  declare readonly answerTargets: HTMLElement[]
  declare readonly questionTargets: HTMLElement[]
  declare readonly questionContainerTarget: HTMLElement
  declare readonly answerContainerTarget: HTMLElement
  declare readonly hideSelectedQuestionValue: boolean

  select(event: Event): void {
    const radio = event.currentTarget as HTMLInputElement
    const questionKey = radio.value;

    this.answerTargets.forEach(el => {
      el.classList.toggle("is-completely-hidden", el.dataset.questionAnswerKey !== questionKey)
    });

    this.answerContainerTarget.classList.remove("is-completely-hidden");

    if (this.hideSelectedQuestionValue) {
      this.questionContainerTarget.classList.add("is-completely-hidden");
    }
  }

  reset(): void {
    this.answerContainerTarget.classList.add("is-completely-hidden");
    this.questionContainerTarget.classList.remove("is-completely-hidden");

    this.questionTargets.forEach(el => {
      el.querySelectorAll<HTMLInputElement>('input[type="radio"]').forEach((input) => input.checked = false)
    })
  }
}
